import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { ReactPlayerProps } from 'react-player';
import usePractitionerControlsContext from '../../../../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { AudioUploadStyle } from './AudioUploadStyle';
import useUploadContext from '../../../../../../../hooks/useUploadContext/useUploadContext';
import DialogMediaPlayer from '../../../../../../DialogMediaPlayer/DialogMediaPlayer';
import { PLayerTriggeredBy } from '../../../../../../../commands/practitioner/enums/PLayerTriggeredBy';
import UploadProgress from '../../../../../../UI/UploadProgress/UploadProgress';

interface AudioUploadProps {
  className?: string;
  index: number;
  value: number;
}

const AudioUpload = (props: AudioUploadProps) => {
  const { practitionerMediaURI, isMediaLoaded } = usePractitionerControlsContext();
  const { isLoading, audioTypeFilename, progress } = useUploadContext();
  const { videoTabContainer } = AudioUploadStyle;
  const { index, value } = props;
  const config = {
    youtube: {
      playerVars: {
        showinfo: 1,
        origin: window.location.origin,
      },
    },
  };

  const reactPlayerPreview: ReactPlayerProps = {
    url: practitionerMediaURI,
    width: '100%',
    height: '100%',
    config,
    controls: false,
  };

  return (
    <>
      {index === value && (
        <Box sx={videoTabContainer} role="tabpanel">
          <>
            {isLoading ? (
              <UploadProgress />
            ) : (
              <Box className={'audio-container'}>
                {!!practitionerMediaURI && isMediaLoaded ? (
                  <>
                    <DialogMediaPlayer
                      key={practitionerMediaURI}
                      ReactPlayerProps={reactPlayerPreview}
                      ReactPlayerTriggeredBy={PLayerTriggeredBy.Practitioner}
                    />
                    <Box className="audio-uploaded">
                      <Typography className="uploaded-text">{audioTypeFilename}</Typography>
                    </Box>
                  </>
                ) : null}
              </Box>
            )}
          </>
        </Box>
      )}
    </>
  );
};

export default AudioUpload;
